import { apiClient } from 'shared/lib/apiClient';

export type CourierOtpMethod = 'sms' | 'email';

export interface CourierSummary {
  submissionId: string;
  fullName: string;
  phone: string;
  email: string;
}

export interface CredentialsResult {
  ticketId: string;
  availableMethods: CourierOtpMethod[];
  maskedPhone?: string;
  maskedEmail?: string;
}

export interface ChallengeResult {
  challengeId: string;
  otpExpiresIn: number;
  sentTo: string;
  devOtp?: string;
}

export const verifyCredentials = async (params: {
  phone: string;
}): Promise<CredentialsResult> => {
  const { data } = await apiClient.post<CredentialsResult>(
    '/api/courier-auth/verify-credentials',
    params,
  );
  return data;
};

export const sendOtp = async (
  ticketId: string,
  method: CourierOtpMethod,
): Promise<ChallengeResult> => {
  const { data } = await apiClient.post<ChallengeResult>(
    '/api/courier-auth/send-otp',
    { ticketId, method },
  );
  return data;
};

export const resendOtp = async (challengeId: string): Promise<ChallengeResult> => {
  const { data } = await apiClient.post<ChallengeResult>(
    '/api/courier-auth/resend-otp',
    { challengeId },
  );
  return data;
};

export const verifyOtp = async (
  challengeId: string,
  code: string,
): Promise<{ courier: CourierSummary }> => {
  const { data } = await apiClient.post<{ courier: CourierSummary }>(
    '/api/courier-auth/verify-otp',
    { challengeId, code },
  );
  return data;
};

export const logout = async (): Promise<void> => {
  await apiClient.post('/api/courier-auth/logout');
};

export const fetchMe = async (): Promise<CourierSummary> => {
  const { data } = await apiClient.post<CourierSummary>('/api/courier-auth/me');
  return data;
};
